import React from "react";
import { EyeIcon } from "lucide-react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { toast } from "react-hot-toast";

const FileActions = ({
  onPreview,
  onDownload,
  isLoading = false,
  previewLabel = "Көру",
  downloadLabel = "Жүктеп алу",
  className = "",
  buttonClassName = "flex items-center justify-center gap-2 bg-[#F3DA6D] hover:bg-[#ebd059] flex-1 py-4 text-black font-bold rounded-xl transition-colors",
}) => {
  return (
    <div className={`flex gap-3 ${className}`}>
      <button
        onClick={onPreview}
        disabled={isLoading}
        className={`${buttonClassName} disabled:opacity-50 disabled:cursor-not-allowed`}
      >
        {isLoading ? (
          <div className="animate-spin h-5 w-5 border-2 border-black border-t-transparent rounded-full" />
        ) : (
          <EyeIcon className="w-5 h-5" />
        )}
        {previewLabel}
      </button>

      <button onClick={onDownload} className={buttonClassName}>
        <ArrowDownTrayIcon className="w-5 h-5" />
        {downloadLabel}
      </button>
    </div>
  );
};

export default FileActions;
